import { EmptyState } from '@repo/common/components';
import { EntityType } from '@repo/common/enums/entityType';
import { entityModalStore } from '../../../components/EntityModal/store';

interface BiDashboardEmptyStateProps {
	onAddMetric?: () => void;
	hasUseButtonPermission?: boolean;
}

export function BiDashboardEmptyState({
	onAddMetric,
	hasUseButtonPermission,
}: BiDashboardEmptyStateProps) {
	const handleLearnMore = () => {
		window.open('https://docs.secoda.co/features/dashboards', '_blank');
	};

	const handleAddMetric = () => {
		if (onAddMetric) {
			onAddMetric();
		} else {
			// Open the entity modal to create a new metric
			entityModalStore.open({
				type: EntityType.metric,
			});
		}
	};

	return (
		<EmptyState
			iconName="deviceDesktopAnalytics"
			title="Start building your dashboard"
			stateHeight={'100%'}
			width="100%"
			description="Dashboards let you bring together insights into a single page. Use them to track key metrics, monitor trends, and explore data in one place."
			buttons={[
				{
					name: 'Learn more',
					action: handleLearnMore,
					size: 'md',
					isPrimary: false,
					rightIconName: 'externalLink',
				},
				{
					name: 'Add metric',
					action: handleAddMetric,
					size: 'md',
					isPrimary: true,
					requiresUseButtonPermission: true,
				},
			]}
			includeGoBack={false}
			size="sm"
			withBorder={true}
			hasUseButtonPermission={hasUseButtonPermission}
		/>
	);
}
